import * as React from "react";
import react, { useState } from "react";
import { IoMailOutline } from "react-icons/io5";
import Container from "./styled";
import ReCAPTCHA from "react-google-recaptcha";
import axios from 'axios'

export default function FormularioContacto() {
  const [formValues, setFormValues] = useState({});
  const [formErrors, setFormErrors] = useState({});

  // Captcha
  function onChange(value) {
    console.log("Captcha value:", value);
    setFormValues((prev) => ({ ...prev, ["captcha"]: value }));
  }

  // Inputs
  function handleChange(e) {
    const { name, value } = e.target;
    setFormValues((prev) => ({ ...prev, [name]: value }));
  }

  // Validación del formulario
  const validateForm = (e) => {
    e.preventDefault();
    let errors = {};

    if (!formValues.nombre) {
      errors.nombre = "Este campo es requerido.";
    }

    if (!formValues.email) {
      errors.email = "Este campo es requerido.";
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formValues.email)) {
      errors.email = "El email ingresado no es valido.";
    }

    // Validar teléfono
    if (!formValues.telefono) {
      errors.telefono = "Este campo es requerido.";
    } else if (formValues.telefono.length < 8) {
      errors.telefono = "El campo telefono es menor a 8 digitos.";
    }

    if (!formValues.mensaje) {
      errors.mensaje = "Este campo es requerido.";
    }

    /*
    if (!formValues.captcha) {
      errors.captcha = "Este campo es requerido.";
    }
    */

    console.log(errors);
    setFormErrors(errors);

    if (Object.keys(errors).length === 0) {
      console.log("Todo OK");
      sendMail()
    }
  };

  // Enviar mail
  const sendMail = async () => {
    const mailContent = `
      <html><body>
        <h2>Contacto</h2>
        <p>Nombre: ${formValues.nombre}<p>
        <p>Teléfono: ${formValues.telefono}<p>
        <p>Asunto: ${formValues.asunto}<p>
        <p>${formValues.mensaje}<p>
      </body></html>
    `
    // Data para el mail
    const mailData = {
      mail: [formValues.email],
      subject: `${formValues.asunto ? formValues.asunto : 'Contacto'}`,
      htmlContent: mailContent
    };

    const sendMail = await axios.post('http://localhost:5000/send_email', mailData)
    console.log(sendMail)
  }  

  return (
    <Container>
      {/* Formulario Container */}
      <div className="formularioTitleContainer opacidad04">
        {/* Title */}
        <h2>Formulario de contacto</h2>
        <form>
          {/* Nombre */}
          <div className="inputContainer">
            <label>
              Nombre <span>*</span>
            </label>
            <input
              placeholder="Nombre"
              name="nombre"
              onChange={handleChange}
              value={formValues.nombre}
            ></input>
          </div>
          {/* Apellido */}
          <div className="inputContainer">
            <label>
              Email <span>*</span>
            </label>
            <input
              placeholder="ejemplo@mail.com"
              name="email"
              onChange={handleChange}
              value={formValues.email}
            ></input>
          </div>
          {/* Teléfono */}
          <div className="inputContainer">
            <label>
              Teléfono <span>*</span>
            </label>
            <input
              placeholder="45892357"
              name="telefono"
              onChange={handleChange}
              value={formValues.telefono}
            ></input>
          </div>
          {/* Asunto */}
          <div className="inputContainer">
            <label>Asunto</label>
            <input
              placeholder="Consulta"
              name="asunto"
              onChange={handleChange}
              value={formValues.asunto}
            ></input>
          </div>
          {/* Mensaje */}
          <div className="inputContainer" id="mensaje">
            <label>
              Mensaje <span>*</span>
            </label>
            <textarea
              placeholder="Escriba aquí su mensaje"
              name="mensaje"
              onChange={handleChange}
              value={formValues.mensaje}
            ></textarea>
          </div>
          {/* ReCAPTCHA Container */}
          <div className="reCaptchaContainer">
            <ReCAPTCHA
              sitekey="6LfvW5YdAAAAADsIry4KRJS5YkcRb7L20iJbYLzQ"
              onChange={onChange}
            />
          </div>
          <button id="formButton" onClick={validateForm}>
            <span>
              <IoMailOutline />
            </span>
            Enviar
          </button>
        </form>
      </div>
      {/* Ilustration Container */}
      <div className="ilustrationContainer opacidad12">
        {/* Ilustration */}
        <img
          alt="Seguro Bici Ilustracion"
          src="images/home/cotizador.svg"
        ></img>
      </div>
      {/* ReCAPTCHA */}
    </Container>
  );
}
